"use client"

import { useSyncExternalStore } from "react"

import { revocationOf, subscribeRevocation } from "@/platform/session/revocation"

import type { QueryClient } from "@tanstack/react-query"

export const useRevocation = (queryClient: QueryClient) =>
  useSyncExternalStore(
    (listener) => subscribeRevocation(queryClient, listener),
    () => revocationOf(queryClient),
    () => "none" as const
  )
